import { render, staticRenderFns } from "./AsingGrid.vue?vue&type=template&id=dd167fe2&scoped=true&"
import script from "./AsingGrid.vue?vue&type=script&lang=js&"
export * from "./AsingGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd167fe2",
  null
  
)

export default component.exports